import React, { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext, PageContext, UserContext, changeLanguage } from "@micado-digital/react-intown-core";
import ReactMetaData01 from "@micado-digital/react-metadata/ReactMetadata01";
import ReactGA from "react-ga";
import DetectLayout from "./detectLayout";

const DetectPage = () => {
	const { NODE_ENV, REACT_APP_PATH, REACT_APP_GOOGLE_ANALYTICS_ID } = process.env;
	const [appData, setAppData] = useContext(AppContext);
	const [pageData, setPageData] = useContext(PageContext);
	const [userData, setUserData] = useContext(UserContext);
	const { i18n } = useTranslation();

	const { href, pathname } = window.location;

	useEffect(() => {
		fetchUser();

		getPage();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname]);

	const fetchUser = async () => {
		if (userData) {
			return null;
		}

		const { REACT_APP_PATH } = process.env;

		const fetchURL = REACT_APP_PATH + "/api/user/data";

		// read and send token

		const headers = {};

		if (localStorage.getItem("logintoken")) {
			headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
		}

		const response = await fetch(fetchURL, {
			headers
		});
		const data = await response.json();

		const authorization = data?.state !== 1 && (await fetchAuthorization());

		const fetchedUserData = {
			...data,
			...authorization
		};

		setUserData(fetchedUserData);
	};

	const fetchAuthorization = async () => {
		const { REACT_APP_PATH } = process.env;

		const fetchURL = REACT_APP_PATH + "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.GuestApi/GetInfo.api";

		// read and send token

		const headers = {};

		if (localStorage.getItem("logintoken")) {
			headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
		}

		const response = await fetch(fetchURL, {
			headers
		});

		const data = await response.json();

		return data;
	};

	const getAppData = async () => {
		if (appData) {
			return;
		}

		const data = await fetchAppData();

		if (!data) return;

		setAppData(data);
	};

	const getPage = async () => {
		if (pageData?.currentFetchedURL === pathname) {
			return;
		}

		const data = await fetchData();

		if (REACT_APP_GOOGLE_ANALYTICS_ID) ReactGA.pageview(window.location.pathname + window.location.search);

		setPageData({
			currentFetchedURL: pathname,
			data
		});

		getAppData();

		if (data?.lang !== i18n.language) {
			changeLanguage(i18n, data?.lang);
			return;
		}
	};

	if (!pageData?.data) {
		return <></>;
	}

	return (
		<>
			<ReactMetaData01
				canonical={pageData?.data.meta?.canonical}
				description={pageData?.data?.meta?.description}
				index={pageData?.data?.meta?.indexable}
				image={pageData?.data?.meta?.image}
				keywords={pageData?.data?.meta?.keywords}
				lang={pageData?.data.lang}
				lat={pageData?.data?.meta?.lat}
				links={pageData?.data?.meta?.links}
				lng={pageData?.data?.meta?.lng}
				title={pageData?.data?.meta?.title}
				twitterCard={pageData?.data?.meta?.twitter?.card}
				twitterSite={pageData?.data?.meta?.twitter?.site}
				url={NODE_ENV === "production" ? href : REACT_APP_PATH + pathname}
			/>
			<DetectLayout />
		</>
	);
};

const fetchData = () => {
	return new Promise((resolve, reject) => {
		const { pathname } = window.location;
		const { REACT_APP_PATH } = process.env;
		let path = ``;

		if (pathname.indexOf(".html") >= 0) {
			path = pathname.replace(".html", ".json");
		} else {
			path = pathname + ".json";
		}

		const fetchURL = REACT_APP_PATH + path;

		// read and send token

		const headers = {};

		if (localStorage.getItem("logintoken")) {
			headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
		}

		fetch(fetchURL, {
			headers
		})
			.then((response) => {
				if (response.status === 401) {
					return { _statusCode: 401 };
				}
				if (response.status === 404) {
					return { _statusCode: 404 };
				}
				return response.json();
			})
			.then((data) => {
				resolve(data);
			});
	});
};

const fetchAppData = () => {
	return new Promise((resolve, reject) => {
		const { REACT_APP_PATH } = process.env;

		const fetchURL = REACT_APP_PATH + "/api/website/profile/data";

		// read and send token

		const headers = {};

		if (localStorage.getItem("logintoken")) {
			headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
		}

		fetch(fetchURL, {
			headers
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				resolve(data);
			});
	});
};

export default DetectPage;
